import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FocusEventHandler } from "react";

type BasePhoneInputProp = {
    styleClass?: string;
    value: string;
    label: string;
    blur?: FocusEventHandler<HTMLInputElement> | undefined;
    id?: string;
    hasError?: boolean;
    errorMsg?: string;
    selectPhone: any;
};

const BasePhoneInput: React.FC<BasePhoneInputProp> = ({
    styleClass = "",
    value,
    label,
    blur,
    id,
    hasError = false,
    errorMsg = "",
    selectPhone
}) => {

  const handleChange = (value: string | any[], data: { dialCode: string | any[]; countryCode: any; }, event: any, formattedValue: any) => {
    selectPhone({
      code: data.dialCode,
      rawMobile: value.slice(data.dialCode.length),
      value,
      countryCode: data.countryCode,
    });
  };
  return (
    <div className={`${styleClass} relative`}>
      <label
        htmlFor={id}
        className="absolute pl-[4rem] text-[14px] text-[#575A65] dark:text-[#575A65] duration-300 transform -translate-y-[0.6rem] scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-[#575A65] peer-focus:dark:text-[#575A65] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-[0.6rem]"
      >
        {label}
      </label>
      <PhoneInput
        inputProps={{
          id: id,
          name: id,
        }}
        country={"ng"}
        enableSearch={true}
        disableDropdown={true}
        // regions={['africa']}
        enableAreaCodeStretch={true}
        countryCodeEditable={true}
        autoFormat={false}
        placeholder="Enter Phone Number"
        value={value}
        onChange={handleChange}
        preferredCountries={["ng", "us", "gb"]}
        onBlur={blur}

        inputStyle={{
          width: 100 + `%`,
          height: 56 + `px`,
          paddingTop: 25 + `px`,
          paddingLeft: 55+`px`,
        }}
      />
      {hasError && (
        <p className="text-[#F85359] text-[12px] pt-1">{errorMsg}</p>
      )}
    </div>
  );
};

export default BasePhoneInput;
